import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styles: ``
})
export class MessageModalComponent {

  title: string = null;
  prompt: string = 'Are you sure?';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  dismissModal(): void {
    this.modal.dismiss();
  }

}
